export interface User {
  id: string;
  email?: string;
  walletAddress: string;
  username?: string;
  avatar?: string;
  role: 'admin' | 'creator' | 'consumer';
  kycStatus?: 'pending' | 'approved' | 'rejected' | 'not_submitted';
  monthlyPrice?: number;
  yearlyPrice?: number;
  paymentWalletAddress?: string;
  acceptedTokens?: string[];
}

export const getToken = (): string | null => {
  return localStorage.getItem('token');
};

export const getUser = (): User | null => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

export const isAuthenticated = (): boolean => {
  return !!getToken();
};

export const logout = (): void => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('rememberMe');
  
  // Clear any other potential auth-related localStorage items
  const keys = Object.keys(localStorage);
  keys.forEach(key => {
    if (key.includes('auth') || key.includes('wallet') || key.includes('session')) {
      localStorage.removeItem(key);
    }
  });
};

export const getAuthHeaders = (): { [key: string]: string } => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};